import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useToast } from '@shared/hooks/use-toast';
import { ManifestListApiAdapter } from '../adapters';

export const useCompleteManifest = () => {
  const { t } = useTranslation('manifestsModule');
  const { toast } = useToast();
  const queryClient = useQueryClient();
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new ManifestListApiAdapter(httpClient);

  return useMutation({
    mutationFn: (manifestId: number) => adapter.complete(manifestId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['manifests'] });
      toast({
        title: t('toast.completeSuccess', 'Manifiesto completado'),
        variant: 'default',
      });
    },
    onError: (error: any) => {
      toast({
        title: t('toast.completeError', 'Error al completar el manifiesto'),
        description: error?.response?.data?.message || error.message,
        variant: 'destructive',
      });
    },
  });
};
